import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.91536 7.91536L11.0514 4.53127C12.2348 3.28127 13.6264 2.67293 15.4598 4.39793C17.3014 6.1396 16.7681 7.5646 15.5848 8.8146L12.4987 12.082M5.92017 9.96252L5.06496 10.8677L4.20976 11.7729C3.95142 12.0479 3.70142 12.5896 3.65142 12.9646L3.34309 15.6646C3.23476 16.6396 3.93476 17.3063 4.90142 17.1396L7.58476 16.6813C7.95976 16.6146 8.48476 16.3396 8.74309 16.0563L10.4154 14.2862",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M9.91016 5.74219C10.2685 8.04219 12.1352 9.80052 14.4518 10.0339",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M3 7L14 18",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-miterlimit": "10",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }